// extracted by mini-css-extract-plugin
module.exports = {"icon":"MagnifyingGlassIcon__icon___Qt-MD"};